import { ItemRowSize } from './types'
import { ThumbnailSize } from '@/tools/ui'

const mapperThumbnailSize: Map<ItemRowSize, ThumbnailSize> = new Map([
  [ItemRowSize.small, ThumbnailSize.xsmall],
  [ItemRowSize.medium, ThumbnailSize.small],
])

export const getThumbnailSize = (size: ItemRowSize) =>
  mapperThumbnailSize.get(size) || ThumbnailSize.xsmall
